import styled from 'styled-components';
import { Segment, Loader } from 'semantic-ui-react';

export const SemanticLoader = styled(Loader)``;

export const SemanticSegment = styled(Segment)`
  background-color: transparent !important;
  background: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #fff !important;
  margin: auto !important;
  border:none;
  
`;

export const SemanticSegmentDiv = styled.div`
  background-color: transparent !important;
  background: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #fff !important;
  margin: auto !important;
  border:none;
  
`;
